// utils/unitedKingdomDepartmentConfig.js - UK Department Configuration

export const unitedKingdomDepartmentConfig = {

    'prime-ministers-office': {
      departmentInfo: {
        name: "Prime Minister's Office",
        image: '/uk-no10.svg',
        officialURL: 'https://www.gov.uk/government/organisations/prime-ministers-office-10-downing-street',
        missionStatement: 'The Prime Minister\'s Office supports the Prime Minister in providing leadership and direction to HM Government.',
        route: '/uk/prime-ministers-office',
        urlKey: 'prime-ministers-office'
      },
      mainFeeds: [
        {
          id: 'no10',
          name: "Prime Minister's Office",
          apiParams: '&skip=0&schema=united_kingdom&table=prime_minister&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'N/A',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    
  
    'cabinet-office': {
      departmentInfo: {
        name: 'Cabinet Office',
        image: '/uk-cabinet-office.svg',
        officialURL: 'https://www.gov.uk/government/organisations/cabinet-office',
        missionStatement: 'The Cabinet Office supports the Prime Minister and Cabinet, helping to ensure the effective running of government.',
        route: '/uk/cabinet-office',
        urlKey: 'cabinet-office'
      },
      mainFeeds: [
        {
          id: 'cabinetOffice',
          name: 'Cabinet Office',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Cabinet%20Office',
          feedBranch: 'Executive',
          feedTopic: 'Government',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'foreign-commonwealth-development-office': {
      departmentInfo: {
        name: 'Foreign, Commonwealth & Development Office',
        image: '/uk-fcdo.svg',
        officialURL: 'https://www.gov.uk/government/organisations/foreign-commonwealth-development-office',
        missionStatement: 'The FCDO promotes the UK\'s interests abroad, provides consular services, and leads on international development.',
        route: '/uk/foreign-commonwealth-development-office',
        urlKey: 'foreign-commonwealth-development-office'
      },
      mainFeeds: [
        {
          id: 'fcdo',
          name: 'Foreign, Commonwealth & Development Office',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Foreign%20Commonwealth%20Development%20Office',
          feedBranch: 'Executive',
          feedTopic: 'Foreign Affairs',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'home-office': {
      departmentInfo: {
        name: 'Home Office',
        image: '/uk-home-office.svg',
        officialURL: 'https://www.gov.uk/government/organisations/home-office',
        missionStatement: 'The Home Office leads on immigration, security, and law and order to keep the UK safe and secure.',
        route: '/uk/home-office',
        urlKey: 'home-office'
      },
      mainFeeds: [
        {
          id: 'home-office',
          name: 'Home Office',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Home%20Office',
          feedBranch: 'Executive',
          feedTopic: 'Home Affairs',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'ministry-of-defence': {
      departmentInfo: {
        name: 'Ministry of Defence',
        image: '/uk-mod.svg',
        officialURL: 'https://www.gov.uk/government/organisations/ministry-of-defence',
        missionStatement: 'The Ministry of Defence protects the security and interests of the UK through the Armed Forces.',
        route: '/uk/ministry-of-defence',
        urlKey: 'ministry-of-defence'
      },
      mainFeeds: [
        {
          id: 'mod',
          name: 'Ministry of Defence',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Ministry%20Of%20Defence',
          feedBranch: 'Executive',
          feedTopic: 'Defense',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'ministry-of-justice': {
      departmentInfo: {
        name: 'Ministry of Justice',
        image: '/uk-moj.svg',
        officialURL: 'https://www.gov.uk/government/organisations/ministry-of-justice',
        missionStatement: 'The Ministry of Justice works to protect and advance the principles of justice, ensuring the justice system is fair, efficient and effective.',
        route: '/uk/ministry-of-justice',
        urlKey: 'ministry-of-justice'
      },
      mainFeeds: [
        {
          id: 'moj',
          name: 'Ministry of Justice',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Ministry%20Of%20Justice',
          feedBranch: 'Executive',
          feedTopic: 'Justice',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'department-of-health-and-social-care': {
      departmentInfo: {
        name: 'Department of Health and Social Care',
        image: '/uk-dhsc.svg',
        officialURL: 'https://www.gov.uk/government/organisations/department-of-health-and-social-care',
        missionStatement: 'DHSC leads, shapes and funds health and social care in England, making sure people have the support, care and treatment they need.',
        route: '/uk/department-of-health-and-social-care',
        urlKey: 'department-of-health-and-social-care'
      },
      mainFeeds: [
        {
          id: 'dhsc',
          name: 'Department of Health and Social Care',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20Of%20Health%20And%20Social%20Care',
          feedBranch: 'Executive',
          feedTopic: 'Health',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'department-for-education': {
      departmentInfo: {
        name: 'Department for Education',
        image: '/uk-dfe.svg',
        officialURL: 'https://www.gov.uk/government/organisations/department-for-education',
        missionStatement: 'DfE is responsible for education and children\'s services in England.',
        route: '/uk/department-for-education',
        urlKey: 'department-for-education'
      },
      mainFeeds: [
        {
          id: 'dfe',
          name: 'Department for Education',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Education',
          feedBranch: 'Executive',
          feedTopic: 'Education',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'department-for-transport': {
      departmentInfo: {
        name: 'Department for Transport',
        image: '/uk-dft.svg',
        officialURL: 'https://www.gov.uk/government/organisations/department-for-transport',
        missionStatement: 'DfT works to create a transport system that helps deliver a thriving economy and a better environment.',
        route: '/uk/department-for-transport',
        urlKey: 'department-for-transport'
      },
      mainFeeds: [
        {
          id: 'dft',
          name: 'Department for Transport',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Transport',
          feedBranch: 'Executive',
          feedTopic: 'Infrastructure',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'department-for-business-and-trade': {
      departmentInfo: {
        name: 'Department for Business and Trade',
        image: '/uk-dbt.svg',
        officialURL: 'https://www.gov.uk/government/organisations/department-for-business-and-trade',
        missionStatement: 'DBT supports businesses to invest, grow and export, creating jobs and opportunities across the country.',
        route: '/uk/department-for-business-and-trade',
        urlKey: 'department-for-business-and-trade'
      },
      mainFeeds: [
        {
          id: 'dbt',
          name: 'Department for Business and Trade',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Business%20And%20Trade',
          feedBranch: 'Executive',
          feedTopic: 'Economy',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'department-for-work-and-pensions': {
      departmentInfo: {
        name: 'Department for Work and Pensions',
        image: '/uk-dwp.svg',
        officialURL: 'https://www.gov.uk/government/organisations/department-for-work-and-pensions',
        missionStatement: 'DWP helps people into work and supports those who cannot work with benefit payments.',
        route: '/uk/department-for-work-and-pensions',
        urlKey: 'department-for-work-and-pensions'
      },
      mainFeeds: [
        {
          id: 'dwp',
          name: 'Department for Work and Pensions',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Work%20Pensions',
          feedBranch: 'Executive',
          feedTopic: 'Economy',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'department-for-environment-food-rural-affairs': {
      departmentInfo: {
        name: 'Department for Environment, Food & Rural Affairs',
        image: '/uk-defra.svg',
        officialURL: 'https://www.gov.uk/government/organisations/department-for-environment-food-rural-affairs',
        missionStatement: 'DEFRA protects and improves the environment, grows a thriving farming and food sector, and sustains rural communities.',
        route: '/uk/department-for-environment-food-rural-affairs',
        urlKey: 'department-for-environment-food-rural-affairs'
      },
      mainFeeds: [
        {
          id: 'defra',
          name: 'Department for Environment, Food & Rural Affairs',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Environment%20Food%20Rural%20Affairs',
          feedBranch: 'Executive',
          feedTopic: 'Environment',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'department-for-energy-security-and-net-zero': {
      departmentInfo: {
        name: 'Department for Energy Security and Net Zero',
        image: '/uk-desnz.svg',
        officialURL: 'https://www.gov.uk/government/organisations/department-for-energy-security-and-net-zero',
        missionStatement: 'DESNZ secures affordable, clean energy for the UK and leads on reaching net zero emissions.',
        route: '/uk/department-for-energy-security-and-net-zero',
        urlKey: 'department-for-energy-security-and-net-zero'
      },
      mainFeeds: [
        {
          id: 'desnz',
          name: 'Department for Energy Security and Net Zero',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Energy%20Security%20And%20Net%20Zero',
          feedBranch: 'Executive',
          feedTopic: 'Environment',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'department-for-science-innovation-and-technology': {
      departmentInfo: {
        name: 'Department for Science, Innovation and Technology',
        image: '/uk-dsit.svg',
        officialURL: 'https://www.gov.uk/government/organisations/department-for-science-innovation-and-technology',
        missionStatement: 'DSIT drives innovation across the economy and ensures the UK remains a science and technology superpower.',
        route: '/uk/department-for-science-innovation-and-technology',
        urlKey: 'department-for-science-innovation-and-technology'
      },
      mainFeeds: [
        {
          id: 'dsit',
          name: 'Department for Science, Innovation and Technology',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Science%20Innovation%20And%20Technology',
          feedBranch: 'Executive',
          feedTopic: 'Science & Tech',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'attorney-generals-office': {
      departmentInfo: {
        name: "Attorney General's Office",
        image: '/uk-ago.svg',
        officialURL: 'https://www.gov.uk/government/organisations/attorney-generals-office',
        missionStatement: 'The Attorney General\'s Office provides legal advice to government and represents the Crown in court.',
        route: '/uk/attorney-generals-office',
        urlKey: 'attorney-generals-office'
      },
      mainFeeds: [
        {
          id: 'ago',
          name: "Attorney General's Office",
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Attorney%20Generals%20Office',
          feedBranch: 'Executive',
          feedTopic: 'Justice',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'department-for-levelling-up-housing-and-communities': {
      departmentInfo: {
        name: 'Department for Levelling Up, Housing and Communities',
        image: '/uk-dluhc.svg',
        officialURL: 'https://www.gov.uk/government/organisations/department-for-levelling-up-housing-and-communities',
        missionStatement: 'DLUHC creates thriving communities and builds more homes across England.',
        route: '/uk/department-for-levelling-up-housing-and-communities',
        urlKey: 'department-for-levelling-up-housing-and-communities'
      },
      mainFeeds: [
        {
          id: 'dlu-hc',
          name: 'Department for Levelling Up, Housing and Communities',
          apiParams: '&skip=0&schema=united_kingdom&table=ministerial_departments&order_by=created_at&filter_column=category&filter_string=Department%20For%20Levelling%20Up%20Housing%20And%20Communities',
          feedBranch: 'Executive',
          feedTopic: 'Infrastructure',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    }
  
  };
  
  // URL to config key mapping for UK
  const ukUrlToConfigMapping = {
    'prime-ministers-office': 'prime-ministers-office',
    'hm-treasury': 'hm-treasury',
    'cabinet-office': 'cabinet-office',
    'foreign-commonwealth-development-office': 'foreign-commonwealth-development-office',
    'home-office': 'home-office',
    'ministry-of-defence': 'ministry-of-defence',
    'ministry-of-justice': 'ministry-of-justice',
    'department-of-health-and-social-care': 'department-of-health-and-social-care',
    'department-for-education': 'department-for-education',
    'department-for-transport': 'department-for-transport',
    'department-for-business-and-trade': 'department-for-business-and-trade',
    'department-for-work-and-pensions': 'department-for-work-and-pensions',
    'department-for-environment-food-rural-affairs': 'department-for-environment-food-rural-affairs',
    'department-for-energy-security-and-net-zero': 'department-for-energy-security-and-net-zero',
    'department-for-science-innovation-and-technology': 'department-for-science-innovation-and-technology',
    'attorney-generals-office': 'attorney-generals-office',
    'department-for-levelling-up-housing-and-communities': 'department-for-levelling-up-housing-and-communities'
  };
  
  // Helper functions
  export const getUKDepartmentConfig = (departmentKey) => {
    const configKey = ukUrlToConfigMapping[departmentKey] || departmentKey;
    const result = unitedKingdomDepartmentConfig[configKey] || null;
    // console.log(`getUKDepartmentConfig: ${departmentKey} -> ${configKey} -> ${result ? 'FOUND' : 'NOT FOUND'}`);
    return result;
  };
  
  export const getUKDepartmentMainFeeds = (departmentKey) => {
    const dept = getUKDepartmentConfig(departmentKey);
    const mainFeeds = dept ? dept.mainFeeds : [];
    // console.log(`getUKDepartmentMainFeeds: ${departmentKey} -> ${mainFeeds.length} main feeds`);
    return mainFeeds;
  };
  
  export const getUKDepartmentAgencies = (departmentKey) => {
    const dept = getUKDepartmentConfig(departmentKey);
    const agencies = dept ? dept.agencies : [];
    // console.log(`getUKDepartmentAgencies: ${departmentKey} -> ${agencies.length} agencies`);
    return agencies;
  };
  
  export const transformUKAgencyToFeed = (agency) => {
    return {
      id: agency.id,
      name: agency.name,
      displayType: 'normal',
      apiParams: agency.apiParams,
      feedBranch: 'Executive',
      feedTopic: agency.topic,
      buttonName: agency.buttonName || 'Doc'
    };
  };
  
  export default unitedKingdomDepartmentConfig;